import React from "react";
import tw, { styled } from "twin.macro";

import { withHero } from "./withHero";
import HeroImage from "./HeroImage";
import { StyledContainer } from "../../Styled/Container";

const Container = styled(StyledContainer)`
  ${tw`flex flex-wrap bg-neutral-alt`}
`;

const Hero = withHero(({ items, onClickImage, handleClick }) => {
  return (
    <Container width="full">
      {items?.map((item, index) => (
        <HeroImage
          key={index}
          image={item.image}
          onClickImage={onClickImage}
          imageLink={item.imageLink}
          link={item.link}
          handleClick={handleClick}
        />
      ))}
    </Container>
  );
});

export default Hero;
